import React, { useEffect, useState } from "react";
import { collection, onSnapshot, query, orderBy, limit } from "firebase/firestore";
import {
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Container,
  Typography,
} from "@mui/material";
import { db } from "../../firebase";
import AddExcursionModal from "./AddExcursionModal";
import ExcursionDetailsModal from "./ExcursionDetailsModal";

function ClientRegister() {
  const [excursions, setExcursions] = useState([]);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [selectedExcursion, setSelectedExcursion] = useState(null);
  const [detailsModalOpen, setDetailsModalOpen] = useState(false);

  // Écoute en temps réel de la collection "clientExcursions"
  useEffect(() => {
    // const q = query(
    //   collection(db, "clientExcursions"),
    //   orderBy("date", "desc")
    // );
    const q = query(
      collection(db, "clientExcursions"),
      orderBy("date", "desc"),
      limit(10) // <-- seulement 10 derniers
    );
    const unsubscribe = onSnapshot(q, (snapshot) => {
      // const data = [];
      // snapshot.forEach((docSnap) => {
      //   data.push({ id: docSnap.id, ...docSnap.data() });
      // });
      const data = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
      setExcursions(data);
    });
    return () => unsubscribe();
  }, []);

  const handleAddClick = () => {
    setAddModalOpen(true);
  };

  const handleAddModalClose = () => {
    setAddModalOpen(false);
  };

  const handleRowClick = (excursion) => {
    setSelectedExcursion(excursion);
    setDetailsModalOpen(true);
  };

  const handleDetailsModalClose = () => {
    setDetailsModalOpen(false);
    setSelectedExcursion(null);
  };

  return (
    <Container>
      <Typography variant="h5" gutterBottom>
        Excursion Register
      </Typography>
      <Button variant="contained" color="primary" onClick={handleAddClick}>
        Add an Excursion
      </Button>
      <Table style={{ marginTop: 20 }}>
        <TableHead>
          <TableRow>
            <TableCell>Date</TableCell>
            <TableCell>Shift</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {excursions
            .sort((a, b) => {
              // Concatène la date et l'heure pour chaque excursion.
              // Si "shift" ou "shift.time" n'existe pas, on utilise "00:00 AM" par défaut.
              const dateTimeA = new Date(
                `${a.date} ${a.shift?.time || "00:00 AM"}`
              );
              const dateTimeB = new Date(
                `${b.date} ${b.shift?.time || "00:00 AM"}`
              );
              return dateTimeB - dateTimeA;
            })
            .map((excursion) => (
              <TableRow
                key={excursion.id}
                hover
                style={{ cursor: "pointer" }}
                onClick={() => handleRowClick(excursion)}
              >
                <TableCell>{excursion.date}</TableCell>
                <TableCell>
                  {excursion.shift ? excursion.shift.time : ""}
                </TableCell>
                <TableCell>
                  {excursion.shift ? excursion.shift.name : ""}
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
      <AddExcursionModal open={addModalOpen} onClose={handleAddModalClose} />
      {selectedExcursion && (
        <ExcursionDetailsModal
          open={detailsModalOpen}
          onClose={handleDetailsModalClose}
          excursionData={selectedExcursion}
        />
      )}
    </Container>
  );
}

export default ClientRegister;
